import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { NgxImageZoomModule } from "ngx-image-zoom";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { SignupComponent } from "./auth/signup/signup.component";
import { SigninComponent } from "./auth/signin/signin.component";
import { MyordersComponent } from "./myorders/myorders.component";
import { MyaccountComponent } from "./myaccount/myaccount.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { ProductdetailsComponent } from "./productdetails/productdetails.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { TopbarComponent } from "./shared/topbar/topbar.component";
import { ProductlistComponent } from "./productlist/productlist.component";
import { CheckoutItemComponent } from "./checkout-item/checkout-item.component";
import { MyordersListsComponent } from "./myorders-lists/myorders-lists.component";
import { ProductitemComponent } from "./productitem/productitem.component";
import { MatGridListModule } from "@angular/material/grid-list";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";

import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { environment } from "src/environments/environment";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { WishlistComponent } from "./wishlist/wishlist.component";
import { OrdersucesspageComponent } from "./ordersucesspage/ordersucesspage.component";
import { SalestagComponent } from "./salestag/salestag.component";
import { WishlistitemComponent } from "./wishlistitem/wishlistitem.component";
import { AddresspageItemComponent } from "./addresspage-item/addresspage-item.component";
import { AddresspageComponent } from "./addresspage/addresspage.component";
import { HttpClientModule } from "@angular/common/http";
import { HttpClientInMemoryWebApiModule } from "angular-in-memory-web-api";
import { DatePipe } from "@angular/common";
import { MyorderItemComponent } from './myorder-item/myorder-item.component';
import { EManageAddressComponent } from './e-manage-address/e-manage-address.component';
import { EEditAddressComponent } from './e-edit-address/e-edit-address.component';
import { EEditProfileComponent } from './e-edit-profile/e-edit-profile.component';
import { ESearchComponent } from './e-search/e-search.component';
//import { AngularFireAuth, AngularFireAuthModule } from '@angular/fire/auth';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SignupComponent,
    SigninComponent,
    MyordersComponent,
    MyaccountComponent,
    CheckoutComponent,
    ProductdetailsComponent,
    FooterComponent,
    TopbarComponent,
    ProductlistComponent,
    CheckoutItemComponent,
    MyordersListsComponent,
    ProductitemComponent,
    BreadcrumbComponent,
    WishlistComponent,
    WishlistitemComponent,
    OrdersucesspageComponent,
    SalestagComponent,
    AddresspageItemComponent,
    AddresspageComponent,
    MyorderItemComponent,
    EManageAddressComponent,
    EEditAddressComponent,
    EEditProfileComponent,
    ESearchComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    //AngularFireAuthModule,
    //AngularFireAuth,
    NgxImageZoomModule,
    BrowserAnimationsModule,
    MatGridListModule,
    HttpClientModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    // HttpClientInMemoryWebApiModule.forRoot(
    //   InMemoryDataService, { dataEncapsulation: false }
    // )
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
